/* GOPSHOP 7.21 – Halloween
   Countdown + Code kopieren (Hinweis-Leiste, Hero, Formular), WhatsApp-Text mit Code, Gopa mit Hexenhut,
   Spinne an der Glasleiste, Fledermäuse. Läuft nur mit html.gop-hw (theme.liquid); zum Ende wird der Look abgeschaltet.
   Bei „Weniger Bewegung“: keine Fledermäuse/Spinne. */
(function () {
  var de = document.documentElement;
  var H = window.gopHW || {};
  if (!de.classList.contains('gop-hw')) return;
  var EN = !!H.en;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Countdown bis zum Ende ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function fmt(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return (d > 0 ? d + (EN ? 'd ' : ' T ') : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  var iv = 0;
  function tick() {
    var left = (H.end || 0) - Date.now();
    if (left <= 0) {
      clearInterval(iv);
      de.classList.remove('gop-hw', 'gop-hw-fx');
      return;
    }
    var t = fmt(left);
    $$('[data-ghw-cd]').forEach(function (el) { if (el.textContent !== t) el.textContent = t; });
  }
  tick();
  iv = setInterval(tick, 1000);

  /* ---------- Code kopieren ---------- */
  function copy(btn) {
    var code = H.code || '';
    function done() {
      btn.classList.add('is-copied');
      var lb = btn.querySelector('[data-ghw-copy-t]');
      var old = lb ? lb.textContent : '';
      if (lb) lb.textContent = EN ? 'Copied' : 'Kopiert';
      clearTimeout(btn.__ghwT);
      btn.__ghwT = setTimeout(function () { btn.classList.remove('is-copied'); if (lb) lb.textContent = old; }, 1800);
    }
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      ta.remove();
      done();
    }
    try { navigator.clipboard.writeText(code).then(done, fallback); } catch (e) { fallback(); }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ghw-copy]');
    if (!b) return;
    e.preventDefault();
    copy(b);
  });

  /* ---------- WhatsApp-Knöpfe in der Hinweis-Leiste: Code gleich mitschicken ---------- */
  $$('.gop-notice a[href*="wa.me/"]').forEach(function (a) {
    try {
      var u = new URL(a.href);
      var t = u.searchParams.get('text') || '';
      if (H.code && t.indexOf(H.code) < 0) {
        u.searchParams.set('text', t.replace(/[:\s]+$/, '') + (EN ? ' (Halloween code ' : ' (Halloween-Code ') + H.code + '):');
        a.href = u.toString();
      }
    } catch (e) {}
  });

  /* ---------- Gopa bekommt einen Hexenhut ---------- */
  var HAT = '<svg viewBox="0 0 120 100" focusable="false">' +
    '<defs><linearGradient id="ghw-hat-g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#4a2a72"/><stop offset="1" stop-color="#16091f"/></linearGradient></defs>' +
    '<ellipse cx="60" cy="83" rx="57" ry="12" fill="url(#ghw-hat-g)" stroke="rgba(255,255,255,.18)" stroke-width="1.2"/>' +
    '<path d="M31 80C39 59 45 37 53 19c4-9 12-14 24-12-6 4-10 10-12 18 6 20 16 37 25 55z" fill="url(#ghw-hat-g)" stroke="rgba(255,255,255,.16)" stroke-width="1.2"/>' +
    '<path d="M34 71c17 5 38 5 54 0l3 9c-17 5-41 5-60 0z" fill="#ff8a1f"/>' +
    '<rect x="54" y="69.5" width="13" height="11" rx="2" fill="none" stroke="#ffd36b" stroke-width="2.4"/>' +
    '<circle cx="77" cy="7" r="3.2" fill="#ffd36b"/>' +
    '</svg>';
  function hat(host) {
    if (!host || host.querySelector('.ghw-hat')) return;
    var s = document.createElement('span');
    s.className = 'ghw-hat';
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML = HAT;
    host.appendChild(s);
  }
  hat(document.querySelector('.gop-hero__mascot .gop-gopa'));
  hat(document.querySelector('.gop-mascot__toggle'));

  if (reduce || !de.classList.contains('gop-hw-fx')) return;

  /* ---------- Spinne an der Glasleiste: Antippen → klettert hoch, kommt später wieder ---------- */
  var SPIDER = '<svg viewBox="0 0 40 40" focusable="false">' +
    '<g stroke="#1a0f28" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none">' +
    '<path d="M15 18 8 12 3 15M14 22H6l-4 4M15 26l-7 4-2 6M17 29l-4 7"/><path d="M25 18l7-6 5 3M26 22h8l4 4M25 26l7 4 2 6M23 29l4 7"/></g>' +
    '<ellipse cx="20" cy="24" rx="7" ry="8" fill="#1a0f28" stroke="rgba(196,160,255,.55)" stroke-width="1"/>' +
    '<circle cx="20" cy="14" r="4.6" fill="#1a0f28" stroke="rgba(196,160,255,.55)" stroke-width="1"/>' +
    '<circle cx="18.3" cy="13.6" r="1.1" fill="#ff8a1f"/><circle cx="21.7" cy="13.6" r="1.1" fill="#ff8a1f"/></svg>';
  (function spider() {
    var hd = document.querySelector('.section-header .header');
    if (!hd || hd.querySelector('.ghw-spider')) return;
    var w = document.createElement('div');
    w.className = 'ghw-spider';
    w.setAttribute('aria-hidden', 'true');
    w.innerHTML = '<div class="ghw-spider__sw"><i class="ghw-spider__th"></i><button type="button" class="ghw-spider__bd" tabindex="-1">' + SPIDER + '</button></div>';
    hd.appendChild(w);
    var tm = 0;
    w.querySelector('.ghw-spider__bd').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      w.classList.add('is-up');
      clearTimeout(tm);
      tm = setTimeout(function () { w.classList.remove('is-up'); }, 7000);
    });
  })();

  /* ---------- Fledermäuse: kleiner Schwarm zur Begrüßung, danach ab und zu eine ---------- */
  var front = document.querySelector('[data-ghw-front]');
  var tpl = document.getElementById('ghw-bat-tpl');
  if (!front || !tpl || !tpl.content) return;
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function bat(o) {
    if (document.hidden || de.classList.contains('gop-game-playing') || !de.classList.contains('gop-hw-fx')) return;
    var el = tpl.content.firstElementChild.cloneNode(true);
    if (o.rtl) el.classList.add('is-rtl');
    el.style.setProperty('--y', o.y.toFixed(1) + 'vh');
    el.style.setProperty('--w', o.w.toFixed(2) + 'rem');
    el.style.setProperty('--dur', o.dur.toFixed(2) + 's');
    el.style.setProperty('--del', o.del.toFixed(2) + 's');
    el.style.setProperty('--dy', o.dy.toFixed(1) + 'vh');
    el.style.setProperty('--bob', o.bob.toFixed(2) + 's');
    el.addEventListener('animationend', function (e) {
      if (e.target === el && /^ghw-fly/.test(e.animationName)) el.remove();
    });
    front.appendChild(el);
  }
  function flock(n, rtl) {
    var small = window.innerWidth < 750;
    for (var i = 0; i < n; i++) {
      bat({ rtl: rtl, y: rnd(8, 44), w: rnd(small ? 3.8 : 5, small ? 6 : 8.4), dur: rnd(small ? 5.5 : 7, small ? 8 : 10.5), del: i * rnd(0.22, 0.55), dy: rnd(-16, 8), bob: rnd(0.9, 1.5) });
    }
  }
  setTimeout(function () { flock(3, true); }, 1500);
  (function next() {
    setTimeout(function () {
      flock(Math.random() < 0.35 ? 2 : 1, Math.random() < 0.5);
      next();
    }, rnd(15000, 28000));
  })();
})();
